import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import Dropdown from 'components/ReusableComponents/ManageHotel/Dropdown'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import { transactionStatusTypes } from 'features/BookingDetails/types'
import moment from 'moment'
import { useState } from 'react'
import { useToasts } from 'react-toast-notifications'
import bookingsApi from 'services/api/bookings'

const EditBookingDialog = props => {
  const { onClose, reloadResults, subscriberHotelBookingId } = props

  const [checkIn, setCheckIn] = useState(moment(props.checkIn).format('YYYY-MM-DD'))
  const [checkOut, setCheckOut] = useState(moment(props.checkOut).format('YYYY-MM-DD'))
  const [transactionStatus, setTransactionStatus] = useState(props.transactionStatus)
  const [totalRate, setTotalRate] = useState(props.totalRate)

  const [updatingBooking, setUpdatingBooking] = useState(false)

  const { addToast } = useToasts()

  function updateBooking() {
    setUpdatingBooking(true)

    bookingsApi
      .update({
        checkIn,
        checkOut,
        transactionStatus,
        totalRate,
        subscriberHotelBookingId
      })
      .then(() => {
        addToast(`booking ${subscriberHotelBookingId} has updated`, {
          appearance: 'success'
        })
        setUpdatingBooking(false)
        reloadResults()
        onClose()
      })
      .catch(err => {
        setUpdatingBooking(false)
        addToast(`could not update the booking: ${err.toString()}`, {
          appearance: 'error'
        })
      })
  }

  return (
    <ConfirmationDialog
      title="Edit booking"
      onClose={props.onClose}
      positiveMessage="Save changes"
      negativeMessage="Cancel"
      onConfirm={updateBooking}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          opacity: updatingBooking ? 0.5 : 1
        }}
      >
        <TextInput
          label="Check-in"
          value={checkIn}
          type="date"
          onChange={e => setCheckIn(e.target.value)}
        />
        <TextInput
          label="Check-out"
          value={checkOut}
          type="date"
          onChange={e => setCheckOut(e.target.value)}
        />
        <TextInput
          label="Total rate ($)"
          value={totalRate}
          type="number"
          onChange={e => setTotalRate(e.target.value)}
        />
        <Dropdown
          label="Booking status"
          options={transactionStatusTypes}
          value={transactionStatus}
          onChange={e => setTransactionStatus(e.target.value)}
        />
      </div>
    </ConfirmationDialog>
  )
}

export default EditBookingDialog
